import { Component, h } from 'preact'

import { GroupedItems, GroupedItemsList } from '../interfaces'
import GroupedItemList from './GroupedItemList'

interface Props {
    items: GroupedItemsList,
    classes: string
}

interface State {
    isOpen: boolean
}

class DropdownGroupedItemList extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      isOpen: true
    }
  }

  render (props: Props, state: State) {
    const { classes, items } = props
    const { isOpen } = state

    if (!isOpen) return null

    return (
      <div class={classes}>
        { items.map((item: GroupedItems) => <GroupedItemList groupName={item.groupName} items={item.items} onClick={() => this.setState({ isOpen: false })} />)}
      </div>
    )
  }
}

export default DropdownGroupedItemList
